import styled from 'styled-components';
import { cssHelpers } from '~helpers';
var CheckboxInput = styled.input.withConfig({
  displayName: "CheckboxInput",
  componentId: "sc-18u9bak-0"
})(["", " left:0;top:0;"], cssHelpers.hiddenInput);
export default CheckboxInput;